import { render, staticRenderFns } from "./registrationactivityadd.vue?vue&type=template&id=01264e17&scoped=true"
import script from "./registrationactivityadd.vue?vue&type=script&lang=js"
export * from "./registrationactivityadd.vue?vue&type=script&lang=js"
import style0 from "./registrationactivityadd.vue?vue&type=style&index=0&id=01264e17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01264e17",
  null
  
)

export default component.exports